import * as Sentry from "@sentry/react";

import reportErrorSentry from "./reportErrorSentry";

export type SentryBreadcrumbCategory =
  | "action-sheet"
  | "api"
  | "appView"
  | "auth"
  | "chat"
  | "avatar"
  | "errorHandler"
  | "tracker"
  | "websocket";

export const addSentryBreadcrumb = (
  category: SentryBreadcrumbCategory | string,
  message: string,
  level: Sentry.SeverityLevel = "info",
  data?: AnyObject
): void => {
  Sentry.addBreadcrumb({
    category,
    message,
    level,
    data
  });
};

export function logSentryBreadcrumb(
  category: SentryBreadcrumbCategory | string,
  ...msg: unknown[]
): void {
  let message: string;
  if (msg.length === 1 && typeof msg[0] === "string") {
    message = msg[0];
  } else {
    try {
      message = msg.map((m) => JSON.stringify(m)).join(", ");
    } catch (e) {
      reportErrorSentry(e);
      message = "error while stringifying breadcrumb message";
    }
  }

  Sentry.addBreadcrumb({
    category,
    message,
    level: "info"
  });
}
